import PubSub from "underpub-js";

var NavMenu = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

  this.height = this.options.$el.height();
  this.options.$el.addClass("has-loaded");

};

NavMenu.prototype.init = function(){

  var self = this;

  PubSub.subscribe("showNavMenu", function(){
    self.show();
  });

  PubSub.subscribe("hideNavMenu", function(){
    self.hide();
  });


  //
  // Adjusting our nav bar position
  //
  var $navBar = $("[data-nav-bar]");
	var $gdprBanner = $("[data-gdpr-banner]");

  var adjustTop = function(){

  	var top = $navBar.height();

  	if($gdprBanner.length && ! $gdprBanner.hasClass("is-closed")){
  		top += 75;
		}

  	self.options.$el.css({top: top});

  };

  $(window).on("resize", function(){
    window.requestAnimationFrame(adjustTop);
  });

  // so that we can set our nav bar adjusted for gdpr
  $(window).trigger("resize");

};

/**
 * Showing menu
 * @return {[type]} [description]
 */
NavMenu.prototype.show = function(){

  this.options.$el.addClass("is-active");
  this.options.$el.height(this.height);

};

/**
 * Showing menu
 * @return {[type]} [description]
 */
NavMenu.prototype.hide = function(){

  this.options.$el.removeClass("is-active");
  this.options.$el.height(0);

};

export default  NavMenu;
